'use client';

type PlanSummary = {
  id: string;
  priceId: string;
};

export async function openStripeResubscribeFlow(fallbackPath: string): Promise<void> {
  // 1) Open Stripe Checkout first (direct subscription payment page).
  try {
    const productsRes = await fetch('/api/stripe/products');
    const productsData = await productsRes.json().catch(() => ({}));
    const plans = Array.isArray(productsData?.plans) ? (productsData.plans as PlanSummary[]) : [];
    const monthlyPlan = plans.find((p) => p.id === 'monthly');
    const selectedPlan = monthlyPlan ?? plans[0];

    if (selectedPlan?.priceId) {
      const checkoutRes = await fetch('/api/stripe/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ priceId: selectedPlan.priceId }),
      });
      const checkoutData = await checkoutRes.json().catch(() => ({}));
      if (checkoutRes.ok && typeof checkoutData?.url === 'string' && checkoutData.url.length > 0) {
        window.location.href = checkoutData.url;
        return;
      }
    }
  } catch {
    // Continue with portal fallback.
  }

  // 2) Fallback to Stripe customer portal (billing management area).
  try {
    const portalRes = await fetch('/api/stripe/customer-portal', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ returnUrl: window.location.href }),
    });
    const portalData = await portalRes.json().catch(() => ({}));
    if (portalRes.ok && typeof portalData?.url === 'string' && portalData.url.length > 0) {
      window.location.href = portalData.url;
      return;
    }
  } catch {
    // Continue with checkout fallback.
  }

  // 3) Last fallback to in-app subscribe page.
  window.location.href = fallbackPath;
}
